<template>
    <div>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-container v-else>
            <form @submit.prevent="add_reports" autocomplete="off">
                <v-layout row wrap>
                    <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-select v-model="reports.report_type" :items="report_types" item-text="name" item-value="value"
                            :label="$store.getters.lang.data.report_type" outlined class="mx-1" filled required rounded>
                        </v-select>
                    </v-flex>
                    <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field v-model="reports.report_text" type="text"
                            :label="$store.getters.lang.data.report_text" outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 lg2 xl2 md2 sm4>
                        <v-btn rounded color="primary" type="submit" x-large>{{$store.getters.lang.data.add_btn}}
                            reports</v-btn>
                    </v-flex>
                </v-layout>
            </form>
            <v-layout row wrap mt-5>
                <v-flex xs12>
                    <v-card>
                        <v-card-title primary-title>
                            {{$store.getters.lang.data.reports}}
                            <v-spacer></v-spacer>
                            <v-text-field autocomplete="off" v-model="search" append-icon="fas fa-search">
                            </v-text-field>
                        </v-card-title>
                        <v-card-text>
                            <v-data-table :headers="headers" :search="search" :items="rows" class="elevation-0"
                                item-key="report_id">
                                <template v-slot:[`item.report_id`]="{ item }">
                                    <div>
                                        <v-btn icon color="error" :disabled="$store.state.auth.user.admin_role != 'admin'" class="mx-1" @click="select_reports(item)" rounded>
                                            <v-icon>mdi-delete-outline</v-icon>
                                        </v-btn>
                                        <v-btn :to="'/reports-list/'+item.report_id" icon color="secondary" class="mx-1"
                                            rounded>
                                            <v-icon>mdi-pencil-outline</v-icon>
                                        </v-btn>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="delete_dialog" persistent max-width="290">
            <v-card>
                <v-card-title>
                    {{$store.getters.lang.data.delete_question}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" class="elevation-0" @click="delete_dialog = false">
                        {{$store.getters.lang.data.cancel_btn}}
                    </v-btn>
                    <v-btn color="green darken-1" text @click="delete_reports(selected_reports.report_id)">
                        {{$store.getters.lang.data.yes_btn}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.value" :color="snackbar.color">
            {{snackbar.text}}
        </v-snackbar>
    </div>
</template>
<script>
    import controller from './../../controller/reports'
    export default {
        data() {
            return {
                reports: {},
                search: '',
                loading: true,
                snackbar: {
                    value: false,
                    text: '',
                    color: ''
                },
                selected_reports: {},
                delete_dialog: false,
                headers: [

                   


                    {
                        text: this.$store.getters.lang.data.report_type,
                        align: 'start',
                        sortable: true,
                        value: 'report_type',
                    },


                    {
                        text: this.$store.getters.lang.data.report_text,
                        align: 'start',
                        sortable: true,
                        value: 'report_text',
                    },
                     {
                        text: '#',
                        align: 'start',
                        sortable: true,
                        value: 'report_id',
                    },


                ],
            }
        },
        computed: {
            rows() {
                return this.$store.getters.reports
            },
            report_types(){
                return [
                    {
                        name:'comment',
                        value:'comment'
                    },
                    {
                        name:'profile',
                        value:'profile'
                    }
                ]
            }


        },
        mounted() {
            this.read_reports();
        },
        methods: {
            add_reports() {
                controller.add_reports(this.reports).then(r => {
                    if (r.data) {
                        this.reports = {}
                        this.$store.state.reports.push(
                            r.data.new_data
                        )
                        this.snackbar = {
                            value: true,
                            text: 'reports Added',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Fail to add reports',
                            color: 'error'
                        }
                    }
                })
            },
            delete_reports(report_id) {
                controller.delete_reports(report_id).then(r => {
                    this.delete_dialog = false
                    if (r.data) {
                        this.$store.state.reports = this.$store.state.reports.filter(f => {
                            return f.report_id != report_id
                        })
                        this.snackbar = {
                            value: true,
                            text: 'reports Deleted',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Delete Faild',
                            color: 'error'
                        }
                    }
                })
            },
            read_reports() {
                this.loading = true
                controller.get_reports().then(r => {
                    // this.rows = r.data.rows
                    this.loading = false
                })
            },
            select_reports(i) {
                this.selected_reports = i
                this.delete_dialog = true
            },
        },
    }
</script>